import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogAccountMultieditViewGridLayoutService } from '@irb/irb-dialogs/dialog-account-multiedit-view/dialog-account-multiedit-view.grid-layout.service';
import { AssignedAccountsService } from '@irb/irb-clients/assigned-accounts/assigned-accounts-service';
import { IAccount } from '@irb/irb-clients/irb-clients.model';
import { IMultipleAccountEditRequest, AccountName } from "@irb/irb-clients/irb-clients.model";
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import { UtilityService } from '@irb/irb-common/services/utility.service';

export interface DialogAccountMultieditViewConfig {
  data: IMultipleAccountEditRequest;
}

@Component({ standalone: false,
  selector: 'irb-dialog-account-multiedit-view',
  templateUrl: './dialog-account-multiedit-view.component.html',
  styleUrl: './dialog-account-multiedit-view.component.scss'
})
export class DialogAccountMultieditViewComponent implements OnInit {
  gridOptions: any;
  grid: any;
  footerContent: string;
  data: Array<number> = [];
  hasServerSideDatasource: boolean = false;
  overlayType: any;
  _accounts: Array<IAccount> = [];
  multipleAccountEditRequest: IMultipleAccountEditRequest;
  frameworkComponents: any;
  loadingOverlayComponentParams: any;
  private showClearFilters: boolean = false;
  accountSubTypeList: string[] = [];

  constructor(public dialogRef: MatDialogRef<DialogAccountMultieditViewComponent>, 
    @Inject(MAT_DIALOG_DATA) public mdd: DialogAccountMultieditViewConfig,
    private gls: DialogAccountMultieditViewGridLayoutService,
    private aas: AssignedAccountsService,
    private util: UtilityService) {
      this.multipleAccountEditRequest = mdd.data;
      this.multipleAccountEditRequest.baseFilter = this.multipleAccountEditRequest.filter;
    }
  
  get accounts() {
    return this._accounts;
  }

  set accounts(accounts: any) {
    this._accounts = accounts;
  }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: true,
      context: { componentParent: this },
      rowModelType: 'serverSide',
      getRowId: (params: any) => {
        return params.data.accountNumber;
      }
    };
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.loadingOverlayComponentParams = {parentObject: this};
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.footerContent = this.multipleAccountEditRequest.accountCount + " Accounts";
    this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    this.getaccountsubTypeList();
  }

  setDatasource() {
    this.hasServerSideDatasource = true;

    return {
      getRows: (params: any) => {
        this.overlayType = 'loading';
        this.grid.api.showLoadingOverlay();
        
        this.aas.getMultieditSelection(params, this.multipleAccountEditRequest).subscribe((data: any) => {
          if(data?.length > 0) {
            this.accounts = <IAccount[]>data;
            params.success({rowData: this.accounts});          
            this.grid.api.hideOverlay();
          } else {
            this.showClearFilters = this.multipleAccountEditRequest.filter?.length > 0;
            this.grid.api.showNoRowsOverlay();
          }          
        });
      }
    };
  }

  getAssignedAccountName(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
      if(str.length > 0) {
        this.aas.paramsForAcctName = str;
        this.aas.getAssignedAccountName().subscribe((res: Array<AccountName>) => {
            const a: AccountName[] = [];
            
            //group items by account name
            res.forEach((item: AccountName) => {
                let target = a.find((x: AccountName) => x.name === item.name);

                if(target) {
                    let b = target.value.toString().split(",");
                    b.push(item.value);
                    target.value = b.join(",");
                } else {
                    a.push(item);
            }
            });

            d.set(a.filter((x: AccountName) => x.name.toLowerCase().includes(str.toLowerCase())));
        });
      }
  }

  getaccountsubTypeList() {
    this.aas.getComboDropDownValues('accountsubType').subscribe((res: string[]) => {
        res.sort(this.util.sortString);
        this.accountSubTypeList = res;
    });
  }
}
